export default {
  geelyFintech: 'GEELY FINANCIAL TECHNOLOGY LIMITED',
  pageHeader: 'GEELY FINANCIAL TECHNOLOGY LIMITED',
  homePage: 'Home Page',
  aboutUs: 'About',
  aboutUs_1: 'Company Profile',
  aboutUs_2: 'News&Media',
  aboutFintech: 'About',
  aboutFintech1: 'GEELY FINTECH',
  joinUs: 'Careers',
  joinUs_1: 'Social Recruitment',
  joinUs_2: 'Campus Recruitment',
  homePageJoin_1: 'Social',
  homePageJoin_2: 'Campus',
  contactUs: 'Contact',
  careers: 'Careers',
  news: "News",
  homePageTitle: 'ALL IN ONE ONE FOR ALL',
  homePageFirst: 'World-class Leading Fintech Pioneer',
  homePageSecond: 'Regtech Specialist',
  aboutUsContentShort: `We strive to be the leader introducing worldwide leading financial technologies to 
                        power up the innovations and development of Chinese financial institutions.`,
  aboutGeelyFintech: 'About Geely Fintech',
  headquater: 'Headquarter / Chong Qing',
  phone: 'Tel',
  email: 'Email',
  aboutGeelyFintechContents: [
    `Geely Financial Technology Co., Ltd.
     ("Geely Fintech") settled in Liangjiang New Area, Chongqing in June 2020 and began its official operation in November of the same year.
      In the second half of 2023, Geely Fintech has officially become a wholly-owned subsidiary of Geely Holding Group.
    `,
    `
    Geely Fintech has been continuously deepening its presence in the financial technology industry, adhering to innovation and innovation, and has repeatedly received relevant authoritative certifications and awards, injecting strong impetus into the development of the company.Geely Fintech aims to become a leading financial technology company with 100% independent intellectual property rights in the world, benchmarking the most advanced technology in the world, filling the gaps in domestic financial technology, providing comprehensive solutions in regulatory technology, asset management, industrial finance, scenario finance, green finance, etc., and escorting domestic financial institutions to embrace openness.
    `
  ],
  aboutGeelyGroup: 'About Geely',
  aboutGeelyGroupContents: [

    `
    Zhejiang Geely Holding Group (“Geely Holding” / “the Group”) was founded in 1986. In 1997, Geely Holding entered the automotive industry and has since focused our core business on the development and production of automobiles. Geely has continued to grow with a focus on continuous technological innovation, talent development, and strengthening core competitiveness, all the while staying committed to sustainable development. 
    `,

    `
    Since 2012, Geely Holding has ranked among the Fortune Global 500 for twelve consecutive years (ranked 225th in 2023) with assets totaling over 510 billion RMB, and more than 120,000 global employees. Geely Holding ranked among Brand Finance’s Top 10 Most Valuable Auto Portfolio Brands 2022 — the only Chinese auto group on the list. 
    `,
    `
    Geely Holding has established R&D and design centres globally in Shanghai, Hangzhou, Ningbo, Gothenburg, Coventry, California, Frankfurt, etc., with more than 20,000 R&D and design personnel and more than 14,000 innovation patents. Geely Holding operates world-class vehicle and powertrain manufacturing plants in China, U.S., U.K., Sweden, Belgium, and Malaysia, meanwhile owning a worldwide sales and service network comprised of more than 4,000 branches.
    `
  ],
  aboutSAXOBankGroup: 'About The Saxo Bank Group',
  aboutSAXOBankGroupContents: [

    `
    The Saxo Bank Group is a leading fintech specialist that connects people to investment opportunities in global capital 
    markets. As a global leader in multi-asset trading and investment, Saxo’s vision is to enable people to fulfill their financial aspirations and make an impact.  
    `,

    `
    Founded in Copenhagen in 1992, Saxo was one of the first financial institutions to develop an online 
    trading platform that offers everyday investors the same tools and market access as professional traders, 
    large institutions, and fund managers. Clients are at the heart of everything we do at Saxo. As the most 
    innovative and best choice for clients, Saxo offers clients around the world broad access to global capital
    markets across asset classes, where they can trade more than 40,000 instruments in over 20 languages from 
    one single margin account. The Saxo Bank Group also powers more than 120 financial institutions as partners 
    by boosting the investment experience they can offer their clients via our open banking technology. Whether 
    it’s through their investments or the outcome of their investments, Saxo gives clients and partners the 
    tools, platform and knowledge to make an impact.
    `,

    `
    The Saxo Bank Group holds four banking licenses and is well regulated globally. With client assets totaling
     more than 45 billion Euros, Saxo is a global company with local presence, employing more than 2,100 people 
     in financial centres across the world, including London, Singapore, Amsterdam, Zurich, Dubai, Shanghai, Hong
      Kong and Tokyo.
    `,

    `For more information, please visit: http://www.home.saxo. `

  ],
  joinUsContents: [{
    prop: 1,
    label: 'Engineering',
    icon: require('@/assets/icon/technical.png'),
    subs: [
      {
        job: 'Senior C# Developer',
        contents: [
          {
            title: 'Location',
            rows: [
              'Chongqing'
            ]
          },
          {
            title: 'Required Skills',
            rows: [
              '3+ years of work experience',
              'Strong skills in C#',
              'Working knowledge of .NET and SQL for working on SQL Server as back-end database',
              'Should be able to understand the integration points & Upstream/Downstream systems',
              'Work experience in Technology or Capital Markets in China',
              'Experience in China Trading System would be major advantage',
              'Good communication skill. Advanced Chinese and intermediate English',
              '',
              'please send your resume to shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: 'Solution Architect',
        contents: [
          {
            title: 'Location',
            rows: [
              'Chongqing'
            ]
          },
          {
            title: 'Role Responsibility',
            rows: [
              'Drive and review the technical and architectural design of front-to-back solution, while enforcing architectural guidelines and systems coherence by identifying affected systems, services and applications. ',
              'Ascertain feasibility and responsible for T-shirt sizing together with Tech Lead and SCRUM Master to optimize resource utilization. ',
              'Guide the tech team and drive integration of new functionalities/applications to existing systems.',
              'Work with IT and GC Management to define architectural/technical roadmap and strategy',
              'Owner of technical risk. Ensure risks are properly addressed and mitigated. Has high impact downstream effect on operations and risk management in design considerations. ',
              'Collaborate with Infrastructure managers to ensure that infrastructure is smoothly integrated and optimized into solution designs.',
              'Work with project teams to ensure projects run according to the organization\'s release and configuration standards. Help improve such processes.',
              'Review vendor proposals and ensure vendors\' design/implementation meets the acceptance criteria of solution designs. ',
              'Key facilitator in communication between business owners and IT tech team in terms of clarifying requirements, sparring on solutions vis-à-vis business targets and resource/technical constraints.'
            ]
          },
          {
            title: 'Knowledge / Skills / Behaviors ',
            rows: [
              'Familiar with Microsoft platform and development tools. ',
              'Knowledge of technologies (including infrastructure) typically used in Financial Services. Sufficient depth in core components is a big plus e.g. trading systems, back office core components, APIs	',
              'Working knowledge of the Agile methodology and how Solution Architecture aligns within IT',
              'Working knowledge of event driven architecture',
              'Knowledge of software development process, tools and lifecycle',
              'Release Management experience and knowledge of DevOps is a plus.',
              'Knowledge of data architecture is a big plus.',
              'Knowledge of common clouds such as Azure is a big plus.',
              'Knowledge of Enterprise Architecture frameworks such as TOGAF, Zachman framework, FEAF, NIST etc. is nice to have',
              'Independent thinker who is persuasive and assertive. ',
              'Highly creative and resourceful.',
              'Have strong consideration for business KPIs and customer focused.',
              'Able to communicate clearly any constraints, feasibility and available options.',
              'Curious about new technology and continue to learn about them',
              'Quick to learn. Ability to understand concepts on a high level and translate that into details.',
              '',
              'please send your resume to shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: 'Trading System Senior Developer',
        contents: [
          {
            title: 'Location',
            rows: [
              'Chongqing'
            ]
          },
          {
            title: 'Required Skills',
            rows: [
              '3+ years of work experience',
              'Strong skills in C# and C++ ',
              'Working knowledge of  .NET and SQL for working on SQL Server as back-end database',
              'Should be able to understand the integration points & Upstream/Downstream systems',
              'Work experience in Technology or Capital Markets in China',
              'Experience in China Trading System would be major advantage',
              'Good communication skill. Advanced Chinese and intermediate English.'
            ]
          },
          {
            title: 'Target Technology Stack',
            rows: [
              'C++ / C#',
              'SQL',
              '.NET ',
              'Visual Studio 2017',
              'Microservice design',
              '',
              'please send your resume to shtjv@saxobank.com'
            ]
          }
        ]
      },
      {
        job: 'Scrum Master',
        contents: [
          {
            title: 'About the Role',
            rows: [
              `
              The role is a senior member of the tech team. He/she owns Scrum and agile methodology in the team. 
              This role is responsible to drive team delivery utilizing scrums and agile. As the role is encompassing 
              the entire technology stack and delivery process, the successful candidate must demonstrate strong 
              stakeholder management skills.
              `
            ]
          },
          {
            title: 'Required Skills',
            rows: [
              'Experienced in software development lifecycle and changement management lifecycle ',
              'Scrum techniques and artifacts (such as definition of done, user stories, automated testing, backlog refinement)',
              'Adept at refinement, story splitting, estimation, velocity, retrospection, and other Scrum techniques',
              'Knowledge sharing and facilitation skills. A keen teacher of Scrum methodologies. ',
              'IT systems, platform knowledge in Financial industry',
              'Understand Software Quality Assurance and Testing principles and processes',
              'Skillful and effective communication with all stakeholders including scrum team.',
              'Structured and consistent approach e.g. agile planning but consistent approach so as to provide a stability for scrum team',
              'Constructive problem-solving and conflict-resolution ability',
              'Decisive when needed. Unafraid to take ownership or provide professional input in joint decision making process.',
              'While focused on Agility, this person also pays sufficient attention to compliance requirements. ',
              '',
              'please send your resume to shtjv@saxobank.com'
            ]
          }
        ]
      }
    ]
  },
  {
    prop: 2,
    label: 'Business',
    icon: require('@/assets/icon/business.png'),
    subs: [
      {
        job: 'Technical Business Analyst',
        contents: [
          {
            title: 'Location',
            rows: [
              'Chongqing'
            ]
          },
          {
            title: 'Role Responsibility',
            rows: [
              'Solicit and capture/update requirements in cooperation with the business owner, and translate them into specifications for developers to implement along and testers to quality assure',
              'Work with architects and business owners to come up with optimal solutions to business problems and opportunities',
              'Present & articulate local operational practices, vendor applications, & technical solutions',
              'Work actively with functional delivery by reviewing test scenarios and drive UAT’s',
              'Help to Manage the Product/Project Backlog alongside the Business Owner - Keep it prioritized, ensure it is structured and with the right amount of detail.',
              'Ensure adequate functional coverage in testing by reviewing Test Scenarios (involve Business users if necessary)	',
              'Be an expert in futures domain and share knowledge with China and global colleagues',
              'Ensure analysis and specification work contribute to a robust and resilient production platform, technology and operational processes'
            ]
          },
          {
            title: 'Required Skills',
            rows: [
              'Knowledge of the trade flow, application functionalities, financial products & system interfaces',
              'Knowledge of end-to-end futures lifecycle in China where deep knowledge in specific domains are a big plus. ',
              'Strong stakeholder management skills and communication skills i.e. able to focus stakeholders to provide needed requirements',
              'Requirements specification and project management',
              'Able to apply domain/industry knowledge to architecture design discussions.',
              'IT concepts such as architecture, hardware, software and system interfaces',
              '',
              'please send your resume to shtjv@saxobank.com'
            ]
          }
        ]
      }
    ]
  },
  {
    prop: 3,
    label: 'Other',
    icon: require('@/assets/icon/public.png'),
    subs: [
      {
        job: 'Manager/Senior Manager of Legal Dept.',
        contents: [
          {
            title: 'Location',
            rows: [
              'Chongqing'
            ]
          },
          {
            title: 'Role Responsibility',
            rows: [
              'To provide general legal advice, support and services with respect to daily business matters and in projects/transactions to business groups',
              'To support the effort to optimize the company’s legal structure, conditions, and way of working to enable the maximum realization of business objectives',
              'Attend negotiations and meetings to negotiate projects or protect company’s interests with outside parties',
              'Advise and support equity investment and fundraising projects as well as other key investments and business affairs in China',
              'To support the effort to identify, prevent/minimize, and respond to legal and compliance risks',
              'Advise on corporate governance, and responsible for preparation of shareholder/board resolutions and annual regulatory',
              'Manage day-to-day aspects of IP and brand protection activities ',
              'Manage law firms and other related providers, coordinate with internal and external lawyers',
            ]
          },
          {
            title: 'Required Skills',
            rows: [
              'Bachelor or above degree in Chinese laws is required, National Bar certificate is a must',
              '5 years’ above legal experience in Financial related industry ',
              'Self-motivated, result-oriented and good communication skill',
              'Ability to manage multiple tasks simultaneously while meeting multiple deadlines simultaneously',
              'Fluent English and Chinese language skills, both verbal and written',
              '',
              'please send your resume to shtjv@saxobank.com'
            ]
          }
        ]
      }
    ]
  }],


  join: {
    filter: 'Select',
    clear: 'Clear contents',
    searching: "Searching for positions  ",
    searchBtn: "Search",
    posiType: "Types of positions",
    city: "Cities",
    type: "Type",
    empty: "No results!",
  }
}